define('api',['require','ns','core/httpService'],function (require) {
	'use strict';

	var ns = require('ns');

	var HttpService = require('core/httpService');

	var _httpService = undefined;

	var Api = function () {

		_httpService = new HttpService();
	};

	Api.prototype = {

		template: {

			request: function (param, successCallback, errorCallback) {

				var _param = {};
				
				var _errorCallback = _.isFunction(errorCallback) ? errorCallback : function () { };

				_httpService.request({
					type: 'GET',
					url: '/template/request',
					param: _param,
					success: function (data) {

						if (!_.isFunction(successCallback)) {

							return false;
						}

						var status = data.status;

						if (status === 0) {

							successCallback();
						
						} else {

							_errorCallback();
						}
					},
					error: _errorCallback
				});
			}
		},
		
		content: {
			
			getImageResources: function (param, successCallback, errorCallback) {
				
				var _param = {};
				
				_param['content_id'] = param.contentId;
				
				var _errorCallback = _.isFunction(errorCallback) ? errorCallback : function () { };

				_httpService.request({
					type: 'POST',
					url: '/Api/GetImageResources',
					param: _param,
					dataType: 'JSON',
					success: function (data) {

						if (!_.isFunction(successCallback)) {

							return false;
						}
						
						var sanitizedImageList = {};
						
						_.each(data, function (item, index) {
							
							sanitizedImageList[index] = {};
							
							_.each(item['image_dimensions'], function (resource, sizeId) {

								sanitizedImageList[index][sizeId] = {
									width: resource['width'],
									height: resource['height'],
                                    size: resource['size'],
									link: resource['link'],
									description: resource['description'],
									creditLine: resource['credit_line']
								};
							});
						});
						
						successCallback(sanitizedImageList);
					},
					error: _errorCallback
				});
			},
            
            getEmbedSectionContentInfoList: function (param, successCallback, errorCallback) {
                var _errorCallback = _.isFunction(errorCallback) ? errorCallback : function () { };

                _httpService.request({
                    type: 'POST',
                    url: '/Api/GetEmbedSectionContentInfoList',
                    param: param,
                    dataType: 'JSON',
                    success: function (data) {
                        if (!_.isFunction(successCallback)) {
                            return false;
                        }
                        
                        successCallback(data);
                    },
                    error: _errorCallback
                });
            }
		},

		member: {

			resendVerificationEmail: function (param, successCallback, errorCallback) {

				var _param = {
					email: param.email
				};

				var _errorCallback = _.isFunction(errorCallback) ? errorCallback : function () { };

				_httpService.request({
					type: 'POST',
					url: param.localeCode + '/Member/resendVerificationEmail',
					param: _param,
					success: function (data) {

						if (!_.isFunction(successCallback)) {

							return false;
						}

						var status = data.status;

						if (status === 0) {
							successCallback(data);
						} else {
							_errorCallback(data);
						}
					},
					error: _errorCallback
				});
			}
		},
	};

	return Api;
});
